import React from 'react';

import { Checkbox } from '@/shared/components/ui/checkbox/checkbox';
import { useDataTable } from '@/shared/components/ui/data-table/context/data-table-context';

export const useDataTableSelection = () => {
  const { selectableItems, selectedItems, setSelectedItems, data } =
    useDataTable();

  const unchecked = selectedItems.length === 0;
  const indeterminate =
    selectedItems.length > 0 && selectedItems.length < selectableItems.length;
  const checked =
    selectableItems.length === selectedItems.length && selectedItems.length > 0;

  const handleSelectAll = () => {
    if (unchecked || indeterminate) {
      setSelectedItems(selectableItems);
    } else {
      setSelectedItems([]);
    }
  };

  const headerCheckbox = () => {
    return (
      <Checkbox
        disabled={selectableItems.length === 0}
        onClick={handleSelectAll}
        indeterminate={indeterminate}
        checked={checked}
      />
    );
  };

  return {
    unchecked,
    indeterminate,
    checked,
    isEmpty: data.items.length === 0,
    hasSelectedItems: selectedItems.length > 0,
    handleSelectAll,
    headerCheckbox,
  };
};
